import { Component, Ref, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Action, ActionStatus } from '@/application/types';
import { showError } from '@/application/snackbar/service';
import { GetProjectsByBaseProjectNumberQuery } from '../../types';

const projectSearchState = namespace('projectSearch');

@Component
export default class ProjectSearch extends Vue {

  @projectSearchState.Action
  readonly getProjectsByBaseProjectNumber!: Action<GetProjectsByBaseProjectNumberQuery>;

  @projectSearchState.State
  readonly getProjectsByBaseProjectNumberStatus!: ActionStatus;

  @Ref('project-search')
  readonly projectSearchField!: HTMLInputElement;

  search: string = '';

  get isProcessing(): boolean {
    return this.getProjectsByBaseProjectNumberStatus === ActionStatus.InProgress;
  }

  mounted() {
    document.addEventListener('keydown', this.keyListener);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.keyListener);
  }

  keyListener(e: KeyboardEvent): void {
    if (e.key !== 'p') {
      return;
    }

    const exclude = ['input', 'textarea'];
    const source = e.target as HTMLElement;
    if (!source || exclude.includes(source.tagName.toLowerCase())) {
      return;
    }

    e.preventDefault();
    this.projectSearchField.focus();
    // @ts-ignore
    this.projectSearchField.$el.querySelector('input').select();
  }

  onSearchSubmit(): void {
    const baseProjectNumber = this.search;
    const query: GetProjectsByBaseProjectNumberQuery = {
      baseProjectNumber,
    };
    this.getProjectsByBaseProjectNumber(query)
      .then(() => {
        if (this.$route.name !== 'project-search/search') {
          this.$router.push({ name: 'project-search/search' });
        }
      })
      .catch((error) => {
        const message = error.response?.data.message || 'Die Suche ist fehlgeschlagen';
        showError({ message });
      });
  }

}
